import { ReactNode, useEffect, useRef, useState } from "react";
import { Padder, SimpleButton, SimpleContainer, SimplePageTemplate } from "./SimpleElements"
import { JwtImage, PlantImageOverlay } from "../main/Images";
import { NullableString, RdxType, StringObjectDictionary } from "../../../biz/data/Types";
import { FilterSearchType, searchDefaultPageSize, SearchHitMetaDataType, SearchHitType, usePlant, usePlantReducer, usePlantSearch, usePlantSearchApi, usePlantUI } from "../../../biz/hooks/usePlantHooks";
import { useNavigate, useNavigation } from "react-router-dom";
import { useAppData } from "../../../biz/data/useAppData";
import { useTranslation } from "react-i18next";
import { usePricing } from "../../../biz/pricing/usePricing";
import { PlantIframeDialog, PortalContainer } from "../main/Portal";


// ############################# Screen #############################
export const PlantSearch = ({ path }: { path: string }) => {
    const searchUi = usePlantSearch();
    const ui = usePlantUI();
    const { t } = useTranslation();

    const [search, setSearch] = useState<string>("");

    const [plantImageId, setPlantImageId] = useState<NullableString>(undefined);
    const [plantId, setPlantId] = useState<NullableString>(undefined);


    const rowClicked = (plantId: string, e: RowClickType) => {
        if (e == "image") {
            const _plant = searchUi.getPlant(plantId);
            //setPlantImageId(_plant.imageid);
            setPlantId(plantId);

        } else {
            ui.toggleSelected(plantId);
        }
    }




    const texts = ((): { title: string } => {
        if (ui.ui?.type == "ad") {
            return { title: t("add_plants_to_ad") }
        } else if (ui.ui?.type == "assortment") {
            return { title: t("add_plants_to_assortment") }
        }

        return { title: "N/A" };

    })();

    useEffect(() => {
        searchUi.onSearch("");
        (inputRef?.current as any)?.focus();
    }, []);

    useEffect(() => {
        (inputRef?.current as any)?.focus();
    }, [searchUi?.searchResultIds])


    useEffect(() => {
        document.body.classList.add("hide-bottom");

        return () => {
            document.body.classList.remove("hide-bottom");
        }
    }, [])

    const inputRef = useRef(null);
    const numberOfPlantsCount: any = useAppData().numberOfPlantsCount;
    const nav = useNavigate();
    const goback = () => {
        nav(-1);
    }
    return (
        <div>

            <div className="plant-search-top-super">
                <div className="first">
                    <div onClick={goback} className="cursor-pointer" >
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                            <path d="M4.02344 13.2031C3.82812 13.0078 3.75 12.7734 3.75 12.5C3.75 12.2656 3.82812 12.0313 4.02344 11.8359L10.8984 5.27345C11.2891 4.92188 11.875 4.92188 12.2266 5.31251C12.5781 5.66407 12.5781 6.28907 12.1875 6.64063L6.99219 11.5625H20.3125C20.8203 11.5625 21.25 11.9922 21.25 12.5C21.25 13.0469 20.8203 13.4375 20.3125 13.4375H6.99219L12.1875 18.3984C12.5781 18.75 12.5781 19.3359 12.2266 19.7266C11.875 20.1172 11.2891 20.1172 10.8984 19.7656L4.02344 13.2031Z" fill="#9F8E73" />
                        </svg>
                    </div>
                    <div onClick={goback} className="cursor-pointer">
                        {t("goback")}
                    </div>
                    <div></div>
                </div>

                <div className="second">
                    <div className="header">
                        {t("searchAndAddPlants")}
                    </div>
                    <div className="plant-search-top-search">
                        <input
                            ref={inputRef}
                            disabled={searchUi.searching}
                            id="search-input"
                            type="text" className="frm-input"
                            placeholder={t("searchAndAddFromOurDatabaseOfOverXPlants", { count: numberOfPlantsCount })}
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            onKeyUp={(e) => {
                                if (e.keyCode == 13) {
                                    searchUi.onSearch(search);
                                }
                            }} />

                        <div className="search-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M13.5039 8.49219C13.5039 6.71094 12.5352 5.08594 11.0039 4.17969C9.44141 3.27344 7.53516 3.27344 6.00391 4.17969C4.44141 5.08594 3.50391 6.71094 3.50391 8.49219C3.50391 10.3047 4.44141 11.9297 6.00391 12.8359C7.53516 13.7422 9.44141 13.7422 11.0039 12.8359C12.5352 11.9297 13.5039 10.3047 13.5039 8.49219ZM12.5352 13.6172C11.4102 14.4922 10.0039 14.9922 8.50391 14.9922C4.91016 14.9922 2.00391 12.0859 2.00391 8.49219C2.00391 4.92969 4.91016 1.99219 8.50391 1.99219C12.0664 1.99219 15.0039 4.92969 15.0039 8.49219C15.0039 10.0234 14.4727 11.4297 13.5977 12.5547L17.7852 16.7109C18.0664 17.0234 18.0664 17.4922 17.7852 17.7734C17.4727 18.0859 17.0039 18.0859 16.7227 17.7734L12.5352 13.6172Z" fill="#9F8E73" />
                            </svg>
                        </div>


                    </div>
                </div>
            </div>

            <div className="plant-search-top" style={{ display: "none" }}>
                <div className="plant-search-top-header">
                    {t("addPlants")}
                </div>

                <div hidden className="plant-search-top-search">
                    {/* <input
                        ref={inputRef}
                        disabled={searchUi.searching}
                        id="search-input"
                        type="text" className="frm-input"
                        placeholder={asdsa}
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        onKeyUp={(e) => {
                            if (e.keyCode == 13) {
                                searchUi.onSearch(search);
                            }
                        }} />

                    <div className="search-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M13.5039 8.49219C13.5039 6.71094 12.5352 5.08594 11.0039 4.17969C9.44141 3.27344 7.53516 3.27344 6.00391 4.17969C4.44141 5.08594 3.50391 6.71094 3.50391 8.49219C3.50391 10.3047 4.44141 11.9297 6.00391 12.8359C7.53516 13.7422 9.44141 13.7422 11.0039 12.8359C12.5352 11.9297 13.5039 10.3047 13.5039 8.49219ZM12.5352 13.6172C11.4102 14.4922 10.0039 14.9922 8.50391 14.9922C4.91016 14.9922 2.00391 12.0859 2.00391 8.49219C2.00391 4.92969 4.91016 1.99219 8.50391 1.99219C12.0664 1.99219 15.0039 4.92969 15.0039 8.49219C15.0039 10.0234 14.4727 11.4297 13.5977 12.5547L17.7852 16.7109C18.0664 17.0234 18.0664 17.4922 17.7852 17.7734C17.4727 18.0859 17.0039 18.0859 16.7227 17.7734L12.5352 13.6172Z" fill="#9F8E73" />
                        </svg>
                    </div> */}


                </div>

            </div>


            <SimplePageTemplate hideBottom={true}>
                <PlantImageOverlay
                    plantImageid={plantImageId}
                    onClick={() => setPlantImageId(undefined)}
                />

                {/* Header */}
                {/* <div>
                    <div>
                        <h2>{texts.title}</h2>
                    </div>
                    <div>
                        <input disabled={searchUi.searching} type="text" className="frm-input" value={search} onChange={e => setSearch(e.target.value)} onKeyUp={e => {
                            if (e.keyCode == 13) {
                                searchUi.onSearch(search);
                            }
                        }} />
                    </div>
                </div> */}

                {/* Info */}
                {/* <div>
                    Visar antal träffar: {searchUi?.searchMetaData?.pageHitCount ?? 0},
                    Totalt antal träffar: {searchUi?.searchMetaData?.totalHitsCount ?? 0}
                    {((searchUi?.searchMetaData?.suggestions?.length ?? 0) > 0) && (
                        <div>
                            Andra stavningar:
                            {searchUi.searchMetaData?.suggestions?.map((s, idx) => (
                                <span className="search-suggestion" key={s} onClick={() => {
                                    setSearch(s);
                                    searchUi.onSearch(s);
                                }}>
                                    {idx > 0 ? ", " : ""}
                                    <span className="suggestion-text">
                                        {s}
                                    </span>
                                </span>
                            ))}
                        </div>
                    )}
                </div> */}

                <PlantTable
                    checkboxChecked={searchUi.selectedCount > 0}
                    onCheckboxClick={ui.toggleAll}
                >
                    {searchUi?.searchResultIds?.map((pid, idx) => (
                        <PlantTableRow
                            key={pid}
                            idx={idx}
                            id={pid}
                            selected={!!searchUi.selected?.[pid]}
                            onClick={e => rowClicked(pid, e)}
                        />
                    ))}
                </PlantTable>

                {/* Paginator */}
                <TablePaginator
                    totalHitsCount={searchUi.searchMetaData?.totalHitsCount ?? 0}
                    pagesize={searchUi.searchMetaData?.pagesize ?? 0}
                    selectedPageIndex={searchUi.searchMetaData?.pageIndex ?? 0}
                    onPageClicked={e => {
                        searchUi.onSearchNewPage(e);
                        document.getElementById("simple-top-menu")?.scrollIntoView({ behavior: "smooth", block: "center" });
                    }}
                />

                {/* Cart */}
                <BottomCart
                    countSelected={searchUi.selectedCount}
                    onButtonClick={ui.confirmCartClick} />

            </SimplePageTemplate>
            <Padder heightPx={150} />

            <PlantIframeDialog plantId={plantId} close={() => setPlantId(null)} />

        </div>
    )
}

const PlantTable = ({ checkboxChecked, onCheckboxClick, children }: { checkboxChecked: boolean, onCheckboxClick(): void, children: ReactNode }) => {
    return (

        <div>
            <table className="tbl-plants">
                <PlantTableHeader />
                <tbody>
                    {/* <PlantTableFirstRow onCheckboxClick={onCheckboxClick} checkboxChecked={checkboxChecked} /> */}
                    {children}
                </tbody>
            </table>
        </div>
    )
}

// ################################### Components ###################################
type ColumnHeaderClickedType = "name" | "specifictype" | "namelatin" | "planttypeid" | "familyname" | "grupperingText";
const PlantTableHeader = () => {
    const { t } = useTranslation();

    const [sortColumn, setSortColumn] = useState<string>("");
    const [sortOrder, setSortOrder] = useState<"asc" | "desc" | undefined>();

    const onClick = (e: ColumnHeaderClickedType) => {
        if (e === sortColumn) {
            setSortOrder("desc")
        } else {
            setSortColumn(e);
            setSortOrder("asc");
        }
    }

    useEffect(() => {
        //  console.log("sortColumn,sortOrder:", sortColumn, sortOrder);
    }, [sortColumn, sortOrder])



    return (
        <thead>
            <tr>
                <th></th>
                <th onClick={() => onClick("name")} id="col-name" className="td-name">
                    <div>{t("name")}</div>
                    <div className="thin">{t("andAlternativeName")}</div>
                </th>
                <th onClick={() => onClick("specifictype")} id="col-specifictype">{t("plant_field_sort")}</th>
                <th onClick={() => onClick("namelatin")} id="col-namelatin">{t("plant_field_latin_name")}</th>
                <th onClick={() => onClick("planttypeid")} id="col-planttypeid">{t("plant_field_type")}</th>
                <th onClick={() => onClick("familyname")} id="col-familyname">{t("plant_field_family")}</th>
                <th onClick={() => onClick("grupperingText")} id="col-grupperingText" className="hide">{t("plant_field_group")}</th>
                <th></th>
            </tr>
        </thead>
    )
}
const PlantTableFirstRow = ({ checkboxChecked, onCheckboxClick }: { checkboxChecked: boolean, onCheckboxClick(): void }) => {
    return (

        <tr className="first-row">
            <td colSpan={7}>
                &nbsp;
            </td>
            <td className="cursor-pointer td-checkbox" onClick={onCheckboxClick}>
                {/* <PlantCheckbox checked={checkboxChecked} /> */}
            </td>
        </tr>
    )
}
type RowClickType = "row" | "image";
const PlantTableRow = ({ idx, id, selected, onClick }: { idx: number, id: string, selected: boolean, onClick(e: RowClickType): void }) => {
    const p = usePlant(id);

    return (
        <tr className={"plant" + (selected ? " selected" : "")}>
            <td className="td-image" onClick={() => {
                if (!!p?.imageid) {
                    onClick("image");
                }
            }}>
                <JwtImage
                    imageId={p?.imageid}
                    plantImage={true}
                    format={"thumb"}
                    title={p?.name + " " + p?.specifictype}
                    imageText={p?.name + " " + p?.specifictype}
                />
            </td>
            <td className="td-name" onClick={() => onClick("row")}>
                <div className="name">
                    {p?.name}
                </div>
                <div className="alternativenames">
                    {p?.alternativenames}
                    {/* ({p?.number_of_owners}) */}
                </div>
            </td>

            <td onClick={() => onClick("row")}>
                <div>{p?.specifictype}</div>
                <div>{p?.alternativename_type}</div>

            </td>
            <td onClick={() => onClick("row")}>
                <div>{p?.namelatin}</div>
                <div>{p?.alternativename_latin}</div>
            </td>
            <td onClick={() => onClick("row")}>{p?.planttypeid}</td>
            <td onClick={() => onClick("row")}>{p?.familyname}</td>
            <td onClick={() => onClick("row")}>{p?.grupperingText}</td>
            <td onClick={() => onClick("row")} className="cursor-pointer td-checkbox">
                <PlantCheckbox checked={selected} />
            </td>
        </tr>
    )
}
export const PlantCheckbox = ({ checked }: { checked: boolean }) => {

    if (checked !== true) {
        return (
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_i_3618_12131)">
                    <path d="M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z" fill="white" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M8.30078 8.99999C8.30078 8.61339 8.61418 8.29999 9.00078 8.29999H23.0008C23.3874 8.29999 23.7008 8.61339 23.7008 8.99999V23C23.7008 23.3866 23.3874 23.7 23.0008 23.7H9.00078C8.61418 23.7 8.30078 23.3866 8.30078 23V8.99999ZM9.70078 9.69999V22.3H22.3008V9.69999H9.70078Z" fill="#ECD6CD" />
                </g>
                <defs>
                    <filter id="filter0_i_3618_12131" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset dy="1" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0.807843 0 0 0 0 0.596078 0 0 0 0 0.509804 0 0 0 0.2 0" />
                        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3618_12131" />
                    </filter>
                </defs>
            </svg>
        )
    }




    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_i_3618_6015)">
                <path d="M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z" fill="white" />
                <path d="M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z" fill="#95AC9D" fillOpacity="0.4" />
                <path d="M13.2517 22.7888C13.0444 22.7888 12.9061 22.7197 12.7679 22.5815L8.2073 17.7444C7.9309 17.468 7.9309 17.0534 8.2073 16.777C8.4837 16.5006 8.89832 16.5006 9.17473 16.777L13.1826 20.9922L22.7875 9.24506C23.0639 8.96866 23.4785 8.89956 23.7549 9.17596C24.0313 9.45236 24.1004 9.86697 23.824 10.1434L13.7354 22.4433C13.6662 22.7197 13.459 22.7888 13.2517 22.7888Z" fill="#3E4B43" />
            </g>
            <defs>
                <filter id="filter0_i_3618_6015" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.807843 0 0 0 0 0.596078 0 0 0 0 0.509804 0 0 0 0.2 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3618_6015" />
                </filter>
            </defs>
        </svg>
    )
}
const TablePaginator = ({ totalHitsCount, pagesize, selectedPageIndex, onPageClicked }: { totalHitsCount: number, pagesize: number, selectedPageIndex: number, onPageClicked(e: number): void }) => {

    const [_selectedPageIndex, setSelectedPageIndex] = useState<number>(selectedPageIndex);

    const pages = pagesize > 0 ? Array.from(Array(Math.ceil(totalHitsCount / pagesize)).keys()) : []; // All pages indices
    const pageCount = pages.length; // Count of pages
    const nextEnabled = _selectedPageIndex < pages?.length - 1;
    const previousEnabled = _selectedPageIndex > 0;

    useEffect(() => { setSelectedPageIndex(selectedPageIndex); }, [selectedPageIndex])

    // Actions
    const selectNext = () => {
        if (nextEnabled) {
            setSelectedPageIndex(_selectedPageIndex + 1);
            onPageClicked(_selectedPageIndex + 1);
        }
    }
    const selectPrevious = () => {
        if (previousEnabled) {
            setSelectedPageIndex(_selectedPageIndex - 1);
            onPageClicked(_selectedPageIndex - 1);
        }
    }

    // Checks
    const isPageVisible = (e: number) => {
        if (pageCount > 5) {
            return Math.abs(e - selectedPageIndex) < 3;
        } else {
            return true;
        }

    }

    if (totalHitsCount <= pagesize) {
        return (null)
    }

    return (
        <div className="tablepaginator">
            <div className="tablepaginator-container">

                <div className="cursor-pointer" onClick={selectPrevious}>
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 8C1 4.13401 4.13401 1 8 1H32C35.866 1 39 4.13401 39 8V32C39 35.866 35.866 39 32 39H8C4.13401 39 1 35.866 1 32V8Z"
                            stroke="#DACFBE"
                            strokeOpacity={previousEnabled ? "1" : "1"}
                            strokeWidth="2"
                        />
                        <path d="M14.9145 19.9801C14.9146 19.7377 15.0027 19.5035 15.1625 19.3211L21.2925 12.3211C21.3764 12.2139 21.4813 12.125 21.6008 12.0598C21.7202 11.9946 21.8517 11.9544 21.9872 11.9418C22.1228 11.9292 22.2594 11.9444 22.3889 11.9864C22.5183 12.0284 22.6378 12.0965 22.74 12.1863C22.8423 12.2761 22.9251 12.3859 22.9835 12.5088C23.0418 12.6318 23.0744 12.7654 23.0793 12.9014C23.0842 13.0374 23.0613 13.173 23.012 13.2998C22.9627 13.4267 22.888 13.5421 22.7925 13.6391L17.2435 19.9801L22.7965 26.3211C22.892 26.4181 22.9667 26.5335 23.016 26.6604C23.0653 26.7873 23.0882 26.9228 23.0833 27.0588C23.0784 27.1949 23.0458 27.3284 22.9875 27.4514C22.9291 27.5744 22.8463 27.6841 22.744 27.774C22.6418 27.8638 22.5223 27.9318 22.3929 27.9738C22.2634 28.0159 22.1268 28.0311 21.9912 28.0184C21.8557 28.0058 21.7242 27.9657 21.6048 27.9004C21.4853 27.8352 21.3804 27.7463 21.2965 27.6391L15.1665 20.6391C15.0053 20.4574 14.9157 20.2231 14.9145 19.9801Z"
                            fill={previousEnabled ? "#74584C" : "#DACFBE"}
                            fillOpacity={previousEnabled ? "1" : "1"}
                        />
                    </svg>
                </div>

                {/* First */}
                {(isPageVisible(0) !== true) && (
                    <>
                        <div
                            className={"item" + (_selectedPageIndex === 0 ? " selected" : "")}
                            onClick={() => onPageClicked(0)}
                        >1
                        </div>

                        {(isPageVisible(1) !== true) && (
                            <div className="dots">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.5 10C16.5 10.5625 16.1875 11.0312 15.75 11.3125C15.2812 11.5938 14.6875 11.5938 14.25 11.3125C13.7812 11.0312 13.5 10.5625 13.5 10C13.5 9.46875 13.7812 9 14.25 8.71875C14.6875 8.4375 15.2812 8.4375 15.75 8.71875C16.1875 9 16.5 9.46875 16.5 10ZM11.5 10C11.5 10.5625 11.1875 11.0312 10.75 11.3125C10.2812 11.5938 9.6875 11.5938 9.25 11.3125C8.78125 11.0312 8.5 10.5625 8.5 10C8.5 9.46875 8.78125 9 9.25 8.71875C9.6875 8.4375 10.2812 8.4375 10.75 8.71875C11.1875 9 11.5 9.46875 11.5 10ZM5 11.5C4.4375 11.5 3.96875 11.2188 3.6875 10.75C3.40625 10.3125 3.40625 9.71875 3.6875 9.25C3.96875 8.8125 4.4375 8.5 5 8.5C5.53125 8.5 6 8.8125 6.28125 9.25C6.5625 9.71875 6.5625 10.3125 6.28125 10.75C6 11.2188 5.53125 11.5 5 11.5Z"
                                        fill="#DACFBE" fillOpacity="0.4" />
                                </svg>
                            </div>
                        )}
                    </>
                )}

                {/* Pages */}
                {pages?.map(n => {

                    if (isPageVisible(n) != true) {
                        return (null)
                    }



                    return (
                        <div
                            key={n}
                            className={"item" + (_selectedPageIndex === n ? " selected" : "")}
                            onClick={() => onPageClicked(n)}
                        >
                            {n + 1}
                        </div>
                    )
                })}

                {/* Last */}
                {(isPageVisible(pageCount - 1) !== true) && (
                    <>

                        {(isPageVisible(pageCount - 2) !== true) && (
                            <div className="dots">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.5 10C16.5 10.5625 16.1875 11.0312 15.75 11.3125C15.2812 11.5938 14.6875 11.5938 14.25 11.3125C13.7812 11.0312 13.5 10.5625 13.5 10C13.5 9.46875 13.7812 9 14.25 8.71875C14.6875 8.4375 15.2812 8.4375 15.75 8.71875C16.1875 9 16.5 9.46875 16.5 10ZM11.5 10C11.5 10.5625 11.1875 11.0312 10.75 11.3125C10.2812 11.5938 9.6875 11.5938 9.25 11.3125C8.78125 11.0312 8.5 10.5625 8.5 10C8.5 9.46875 8.78125 9 9.25 8.71875C9.6875 8.4375 10.2812 8.4375 10.75 8.71875C11.1875 9 11.5 9.46875 11.5 10ZM5 11.5C4.4375 11.5 3.96875 11.2188 3.6875 10.75C3.40625 10.3125 3.40625 9.71875 3.6875 9.25C3.96875 8.8125 4.4375 8.5 5 8.5C5.53125 8.5 6 8.8125 6.28125 9.25C6.5625 9.71875 6.5625 10.3125 6.28125 10.75C6 11.2188 5.53125 11.5 5 11.5Z"
                                        fill="#DACFBE" fillOpacity="0.4" />
                                </svg>
                            </div>
                        )}

                        <div
                            className={"item" + (_selectedPageIndex === (pageCount - 1) ? " selected" : "")}
                            onClick={() => onPageClicked(pageCount - 1)}
                        >
                            {pageCount}
                        </div>

                    </>
                )}

                <div className="cursor-pointer" onClick={selectNext}>
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 8C1 4.13401 4.13401 1 8 1H32C35.866 1 39 4.13401 39 8V32C39 35.866 35.866 39 32 39H8C4.13401 39 1 35.866 1 32V8Z"
                            stroke="#DACFBE"
                            strokeOpacity={nextEnabled ? "1" : "1"}
                            strokeWidth="2"
                        />
                        <path d="M25.0855 19.9803C25.0854 20.2228 24.9973 20.457 24.8375 20.6393L18.7075 27.6393C18.6236 27.7465 18.5187 27.8354 18.3992 27.9006C18.2798 27.9659 18.1483 28.006 18.0128 28.0186C17.8772 28.0313 17.7406 28.0161 17.6111 27.9741C17.4817 27.932 17.3622 27.864 17.26 27.7742C17.1577 27.6843 17.0749 27.5746 17.0165 27.4516C16.9582 27.3286 16.9256 27.1951 16.9207 27.0591C16.9158 26.923 16.9387 26.7875 16.988 26.6606C17.0373 26.5338 17.112 26.4183 17.2075 26.3213L22.7565 19.9803L17.2035 13.6393C17.108 13.5424 17.0333 13.4269 16.984 13.3C16.9347 13.1732 16.9118 13.0376 16.9167 12.9016C16.9216 12.7656 16.9542 12.632 17.0125 12.5091C17.0709 12.3861 17.1537 12.2763 17.256 12.1865C17.3582 12.0967 17.4777 12.0286 17.6071 11.9866C17.7366 11.9446 17.8732 11.9294 18.0088 11.942C18.1443 11.9546 18.2758 11.9948 18.3952 12.06C18.5147 12.1252 18.6196 12.2142 18.7035 12.3213L24.8335 19.3213C24.9947 19.5031 25.0843 19.7373 25.0855 19.9803Z"
                            fill={nextEnabled ? "#74584C" : "#DACFBE"}
                            fillOpacity={nextEnabled ? "1" : "1"}
                        />
                    </svg>
                </div>

            </div>
        </div>
    )

}
// ################################### UI Logic ###################################


// ##################################### Hook #####################################
// ##################################### BottomCart #####################################
const BottomCart = ({ countSelected, onButtonClick }: { countSelected: number, onButtonClick(): void }) => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState<boolean>(false);
    const pricing = usePricing();

    useEffect(() => {
        //setVisible(countSelected > 0);
        setVisible(true);
    }, [, countSelected]);

    const nav = useNavigate();

    const plantUI = usePlantUI();


    return (
        <div className={"bottom-cart " + (visible ? "visible" : "hidden")}>
            <div className="bottom-cart-container">
                <div className="item">
                    <div className="go-back" onClick={() => {
                        nav(-1)
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
                            <path d="M4.02344 13.7033C3.82812 13.508 3.75 13.2736 3.75 13.0002C3.75 12.7658 3.82812 12.5314 4.02344 12.3361L10.8984 5.77363C11.2891 5.42207 11.875 5.42207 12.2266 5.81269C12.5781 6.16426 12.5781 6.78926 12.1875 7.14082L6.99219 12.0627H20.3125C20.8203 12.0627 21.25 12.4924 21.25 13.0002C21.25 13.5471 20.8203 13.9377 20.3125 13.9377H6.99219L12.1875 18.8986C12.5781 19.2502 12.5781 19.8361 12.2266 20.2268C11.875 20.6174 11.2891 20.6174 10.8984 20.2658L4.02344 13.7033Z" fill="#9F8E73" />
                        </svg>
                        <div>
                            {t("goback")}
                        </div>
                    </div>
                </div>

                <div className="item flex-1"></div>
                <div className="item">
                    <div className="label">{t("count_selected")}:</div>
                    <div className="count">{t("Xplants", { count: countSelected })}</div>
                </div>

                {/* if assortment => show */}
                {plantUI?.ui?.type === "assortment" && (
                    <div className="item">
                        <div className="label">{t("cost")}:</div>
                        <div className="count">
                            {pricing.assortmentPlantsMonthPriceString(countSelected)}
                            {t("perMonth")}
                        </div>
                    </div>
                )}

                {/* Confirm */}
                <div className="item">
                    <SimpleButton
                        onClick={onButtonClick}
                        label={t("confirm_selection")}
                        type="primarygreen"
                        shape="bigpill"
                    />
                </div>

            </div>
        </div>
    )
}
// ##################################### BottomCart #####################################

